import './unsubscribe-page.scss';
import React, {useEffect, useState} from 'react';
import ADDLogo from '@svg/dd-logo.svg?react';
import CircleCheckIcon from '@svg/circle-check.svg?react';
import Loader from '../shared/loader/loader';
import {useSearchParams} from 'react-router-dom';
import { useNavigate } from 'src/utils/use-navigate';
import customerService from '@src/services/customer.service';


/**
 * Public SPA page for the one-click email unsubscribe flow.
 *
 * Flow:
 *   1. Email link → /unsubscribe?token=<jwt>
 *   2. Page mounts, reads `?token=` from the URL.
 *   3. POSTs { token } as JSON to POST /api/customers/unsubscribe.
 *   4. Shows success / error state based on the response.
 *
 * No authentication is required — this page is accessible without a session.
 */
export const UnsubscribePage: React.FC = () => {
    const [searchParams] = useSearchParams();
    const token = searchParams.get('token');
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const navigate = useNavigate();

    useEffect(() => {
        const unsubscribe = async () => {
            try {
                if (!token || token.trim() === '') {
                    navigate('/unsubscribe-failed', {replace: true});
                    return;
                }
                await customerService.unsubscribe(token);
            } catch(err) {
                console.error('Failed to unsubscribe: ', err);
                navigate('/unsubscribe-failed', {replace: true});
            } finally {
                setIsLoading(false);
            }
        };
        void unsubscribe();
    }, [navigate, token]);

    if (isLoading) {
        return <Loader type={'full-screen'}/>;
    }

    return (
        <div className="unsubscribe-container">
            <div className="unsubscribe-logo">
                <ADDLogo />
            </div>
            <CircleCheckIcon />
            <div className="title">Unsubscribed successfully</div>
            <div className="sub-title">
                You've been unsubscribed from AT&T Dynamic Defense Executive Summary report emails.
            </div>
        </div>
    );
};
